<template>
  <BaseVeeForm
    :action="save"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    class="space-y-8"
  >
    <VModal ref="modal" @modal:hidden="$emit('close')" :disable-backdrop-click="isPending">
      <div class="mx-auto w-full max-w-sm">
        <BaseCard>
          <BaseCardBody>
            <div class="space-y-4">
              <ValidationProvider rules="required" name="first name" slim vid="firstName">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormLabel> First name </BaseFormLabel>
                    <BaseFormInput type="text" v-model="formData.firstName" :disabled="isPending" />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
              <ValidationProvider name="last name" slim vid="lastName">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormLabel> Last name </BaseFormLabel>
                    <BaseFormInput type="text" v-model="formData.lastName" :disabled="isPending" />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </div>
          </BaseCardBody>
          <BaseCardFooter>
            <div class="flex space-x-2">
              <BaseButton primary :disabled="invalid || isPending"> Save </BaseButton>
              <BaseButton
                type="button"
                primary
                outline
                :disabled="isPending"
                @click="$refs.modal.close()"
              >
                Cancel
              </BaseButton>
            </div>
          </BaseCardFooter>
        </BaseCard>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
export default {
  props: {
    action: {
      type: Function,
      required: true,
    },
    defaultData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        ...this.defaultData,
      },
    };
  },
  methods: {
    async save() {
      await this.action(this.formData);

      this.$refs.modal.close();
    },
  },
};
</script>
